import startCase from 'lodash.startcase'

import { UserProviderUserType } from 'src/providers/UserProvider'

import { GetRegistryViewByUriQuery } from 'src/config/generated/graphql'
import { AccountType, MembershipRoleType } from 'src/types/account'
import { ArrayElement } from 'src/types/common'
import { enumToArray } from 'src/utils/common'
import { ALL_SELECT_OPTION, DEFAULT_SELECT_OPTION } from 'src/utils/form'

const baseAccountTypeOptions = [
  ...enumToArray(AccountType)
    .filter(
      o => o !== AccountType[AccountType.Unknown] && !o.startsWith('REM_')
    )
    .map(key => ({
      label: startCase(key),
      value: Object(AccountType)[key]
    }))
]

export const accountTypeOptionsWithAll = [
  ALL_SELECT_OPTION,
  ...enumToArray(AccountType)
    .filter(
      o => o !== AccountType[AccountType.Unknown] && !o.startsWith('REM_')
    )
    .map(key => ({
      label: startCase(key),
      value: key
    }))
]

export const accountTypeOptionsWithUnknown = enumToArray(AccountType)
  .filter(o => !o.startsWith('REM_'))
  .map(key => ({
    label: startCase(key),
    value: key
  }))

export const accountTypeOptions = [
  DEFAULT_SELECT_OPTION,
  ...baseAccountTypeOptions
]

export const membershipRoleOptions = [
  ...enumToArray(MembershipRoleType)
    .filter(
      o =>
        o !== MembershipRoleType[MembershipRoleType.Unknown] &&
        !o.startsWith('REM_')
    )
    .map(key => ({
      label: startCase(key),
      value: Object(MembershipRoleType)[key]
    }))
]

export const isHidden = (
  account:
    | UserProviderUserType['Account']
    | ArrayElement<GetRegistryViewByUriQuery['registries']>['Account']
) => {
  if (account?.Funder && !account?.Funder.IsHidden) return false
  if (account?.Planter && !account?.Planter.IsHidden) return false

  return true
}
